module.exports = __webpack_public_path__ + "img/grand-room-3.e70ac8d1.jpg";